// FlexTypography.tsx
import { Typography, TypographyProps } from '@mui/material'
import * as React from 'react'

type GrowType = number | 'none' | 'auto' | string

type FlexTypographyProps = TypographyProps & {
  /** Shorthand flex. Examples: 1, 2, '0 0 auto', '2 1 0', 'none' */
  flex?: GrowType
  /** If you only want to set grow (number), use grow. Overrides flex if both provided. */
  grow?: number
}

const FlexTypography: React.FC<FlexTypographyProps> = ({ flex, grow, sx, children, ...rest }) => {
  // Resolve final flex shorthand
  let finalFlex: string | number | undefined = flex
  if (typeof grow === 'number') finalFlex = `${grow} 1 0` // weighted cells with ellipsis support

  // Friendly aliases
  if (flex === 'none') finalFlex = '0 0 auto'
  if (flex === 'auto') finalFlex = '1 1 auto'

  return (
    <Typography
      noWrap
      sx={{
        minWidth: 0,
        flex: finalFlex ?? '1 1 0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Typography>
  )
}

export default FlexTypography
